module.exports = __webpack_public_path__ + "img/map_marker.d0009f74.svg";